import React, {
  useEffect,
  useState
} from "react";

import {
  CircularProgress,
  Typography
} from "@material-ui/core";

import api from "../../../services/api";


const normalizeCid = value =>
  String(value || "")
    .trim()
    .replace(/^cid:/i, "")
    .replace(/^</, "")
    .replace(/>$/, "");


const blobToDataUrl = blob =>
  new Promise(
    (resolve, reject) => {

      const reader =
        new FileReader();

      reader.onload =
        () => resolve(
          String(
            reader.result ||
            ""
          )
        );

      reader.onerror =
        reject;

      reader.readAsDataURL(
        blob
      );
    }
  );


const sanitize = doc => {

  doc
    .querySelectorAll(
      "script,iframe,object,embed,form,input,textarea,select,button,base,meta[http-equiv]"
    )
    .forEach(
      node =>
        node.remove()
    );


  doc
    .querySelectorAll("*")
    .forEach(
      node => {

        Array.from(
          node.attributes || []
        ).forEach(
          attr => {

            const name =
              String(
                attr.name || ""
              ).toLowerCase();

            const value =
              String(
                attr.value || ""
              );

            if (
              name.startsWith("on") ||
              name === "srcdoc"
            ) {
              node.removeAttribute(
                attr.name
              );
            }

            if (
              (
                name === "href" ||
                name === "src"
              ) &&
              /javascript\s*:/i.test(
                value
              )
            ) {
              node.removeAttribute(
                attr.name
              );
            }
          }
        );
      }
    );


  const style =
    doc.createElement(
      "style"
    );

  style.textContent = `
    html, body {
      margin: 0;
      padding: 0;
      color: #344054;
      background: #fff;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      line-height: 1.65;
      overflow-wrap: anywhere;
    }

    img {
      max-width: 100% !important;
      height: auto !important;
    }

    table {
      max-width: 100% !important;
    }
  `;

  doc.head.appendChild(
    style
  );
};


const EmailHtmlViewer = ({
  html,
  text,
  companyId,
  mailboxId,
  uid,
  folder,
  attachments = []
}) => {

  // KORAX INLINE EMAIL IMAGES V1

  const [
    source,
    setSource
  ] = useState("");

  const [
    preparing,
    setPreparing
  ] = useState(false);


  useEffect(
    () => {

      let active = true;

      const run =
        async () => {

          const raw =
            String(
              html || ""
            ).trim();

          if (!raw) {
            setSource("");
            return;
          }

          setPreparing(true);

          try {

            const parser =
              new DOMParser();

            const doc =
              parser.parseFromString(
                raw,
                "text/html"
              );


            const images =
              Array.from(
                doc.querySelectorAll(
                  'img[src^="cid:"]'
                )
              );


            for (
              const image of images
            ) {

              const cid =
                normalizeCid(
                  image.getAttribute(
                    "src"
                  )
                );


              const attachment =
                attachments.find(
                  item => {

                    const candidate =
                      normalizeCid(
                        item?.contentId ||
                        item?.contentID ||
                        item?.content_id ||
                        item?.cid
                      );

                    return (
                      candidate &&
                      candidate === cid
                    );
                  }
                );


              const attachmentId =
                attachment?.id ||
                attachment?.attachmentId;


              if (
                !attachmentId ||
                !companyId ||
                !mailboxId ||
                !uid
              ) {
                continue;
              }


              try {

                const response =
                  await api.get(
                    "/email-beta/attachment",
                    {
                      params: {
                        companyId,
                        mailboxId,
                        uid,
                        folder,
                        attachmentId
                      },

                      responseType:
                        "blob"
                    }
                  );


                const dataUrl =
                  await blobToDataUrl(
                    response.data
                  );


                if (!active) {
                  return;
                }


                image.setAttribute(
                  "src",
                  dataUrl
                );

              } catch (_) {
                // Mantem o restante do email legivel.
              }
            }


            sanitize(doc);


            if (active) {

              setSource(
                "<!doctype html>" +
                doc
                  .documentElement
                  .outerHTML
              );
            }

          } finally {

            if (active) {
              setPreparing(false);
            }
          }
        };


      run();

      return () => {
        active = false;
      };

    },
    [
      html,
      companyId,
      mailboxId,
      uid,
      folder,
      attachments
    ]
  );


  if (
    !String(
      html || ""
    ).trim()
  ) {

    return (
      <Typography
        component="div"
        style={{
          color: "#344054",
          fontSize: 12,
          lineHeight: 1.75,
          whiteSpace: "pre-wrap"
        }}
      >
        {text ||
          "Este e-mail não possui conteúdo visível."}
      </Typography>
    );
  }


  if (preparing) {

    return (
      <Typography
        style={{
          color: "#667085",
          fontSize: 10
        }}
      >
        <CircularProgress
          size={14}
          style={{
            marginRight: 8
          }}
        />
        Preparando imagens do e-mail...
      </Typography>
    );
  }


  return (
    <iframe
      title="Conteúdo do e-mail"
      srcDoc={source}
      /* KORAX NEWSLETTER READER V1 */
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{
        display: "block",
        width: "100%",
        minHeight: 450,
        border: 0,
        background: "#FFFFFF"
      }}
    />
  );
};


export default EmailHtmlViewer;
